import { Navigate, Outlet } from "react-router-dom";

import { ROUTES } from "@/constants/routes.constants";
import { useUser } from "@/context/user-provider";

/**
 * `AccessRoute` for super admins only. Temporary: the configuration domains
 * open to other roles later through an access flag.
 */
export const SuperAdminRoute: React.FC = () => {
  const { isSuperAdmin } = useUser();

  if (!isSuperAdmin) {
    return <Navigate to={ROUTES.PROFILE} replace />;
  }

  return <Outlet />;
};
